import { render, staticRenderFns } from "./BookmarkButton.vue?vue&type=template&id=812f16ae&scoped=true&"
import script from "./BookmarkButton.vue?vue&type=script&lang=js&"
export * from "./BookmarkButton.vue?vue&type=script&lang=js&"
import style0 from "./BookmarkButton.vue?vue&type=style&index=0&id=812f16ae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812f16ae",
  null
  
)

export default component.exports